import { StepConnector, stepConnectorClasses, styled } from '@mui/material';

export const StyledMultiStepConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 21,
    left: 'calc(-50% + 40px)',
    right: 'calc(50% + 40px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage: 'linear-gradient(150deg, rgba(0,54,64,1) 1%, rgba(0,74,88,1) 38%, rgba(0,93,111,1) 100%)',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage: 'linear-gradient(150deg, rgba(0,54,64,1) 1%, rgba(0,74,88,1) 38%, rgba(0,93,111,1) 100%)',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 1,
    border: 0,
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
    borderRadius: 1,
  },
}));
